module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<div class=\"container-fluid h-100 app-container\">\n    <div class=\"row h-100\">\n        <app-alert-bar></app-alert-bar>\n        <app-nav-panel class=\"col-auto bg-primary px-0 h-100\"></app-nav-panel>\n        <main class=\"col px-0 h-100 router-outlet-container\">\n            <router-outlet></router-outlet>\n        </main>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main